/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { riskSignalsAnalysisStatus } from "../funcs/riskSignalsAnalysisStatus.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { RiskAnalysisStatusResult } from "../models/components/riskanalysisstatusresult.js";
import {
  GetRiskAnalysisStatusRequest,
  GetRiskAnalysisStatusSecurity,
} from "../models/operations/getriskanalysisstatus.js";
import { unwrapAsync } from "../types/fp.js";
export type RiskAnalysisStatusQueryData = RiskAnalysisStatusResult;

export function prefetchRiskAnalysisStatus(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetRiskAnalysisStatusRequest | undefined,
  security?: GetRiskAnalysisStatusSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildRiskAnalysisStatusQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildRiskAnalysisStatusQuery(
  client$: GramCore,
  request?: GetRiskAnalysisStatusRequest | undefined,
  security?: GetRiskAnalysisStatusSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<RiskAnalysisStatusQueryData>;
} {
  return {
    queryKey: queryKeyRiskAnalysisStatus({
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function riskAnalysisStatusQueryFn(
      ctx,
    ): Promise<RiskAnalysisStatusQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(riskSignalsAnalysisStatus(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyRiskAnalysisStatus(
  parameters: {
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "signals", "analysisStatus", parameters];
}
